import { render, staticRenderFns } from "./priceGroup.vue?vue&type=template&id=0747da32&scoped=true&lang=pug&"
import script from "./priceGroup.vue?vue&type=script&lang=js&"
export * from "./priceGroup.vue?vue&type=script&lang=js&"
import style0 from "./priceGroup.vue?vue&type=style&index=0&id=0747da32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0747da32",
  null
  
)

export default component.exports